// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6521129a","703":"67481644","830":"7a241c1c"}[chunkId] + ".chunk.js";
};